var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpielerPlus = function SvgSpielerPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236 236"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 11.55,
    d: "M219 118c0-55.78-45.22-101-101-101S17 62.22 17 118s45.22 101 101 101 101-45.22 101-101Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M108.13 82.23h20.79a4.9 4.9 0 0 0 4.86-4.93V56.65a4.9 4.9 0 0 0-4.86-4.93h-20.79a4.9 4.9 0 0 0-4.86 4.93V77.3a4.9 4.9 0 0 0 4.86 4.93M173.07 98.01H62.93a4.9 4.9 0 0 0-4.9 4.9v21.39c0 2.7 2.2 4.9 4.9 4.9h39.71v50.18c0 2.7 2.2 4.9 4.9 4.9h20.92c2.7 0 4.9-2.2 4.9-4.9V129.2h39.71c2.7 0 4.9-2.2 4.9-4.9V102.9c0-2.7-2.2-4.9-4.9-4.9"
  }))));
};
export default SvgSpielerPlus;